import { Fragment } from "react";

export default function NotFoundPage() {
    return (
        <Fragment>Not Found</Fragment>
    );
}